import { useRouter } from 'next/router';

import METADATA from 'src/constants/metadata';
import { IArticleByGroupDetail } from 'src/interface';

interface NewsArticleJsonLdCProps {
	article: IArticleByGroupDetail;
}

const NewsArticleJsonLdC = (props: NewsArticleJsonLdCProps) => {
	const r = useRouter();
	const { article } = props;

	const NewsArticleJson = {
		'@context': 'https://schema.org',
		'@type': 'NewsArticle',
		mainEntityOfPage: {
			'@type': 'MedicalWebPage',
			'@id': METADATA.WEB_URL + r.asPath,
		},
		headline: article.title,
		image: {
			'@type': 'ImageObject',
			url: article.thumbnail_url || article.media_images?.[0]?.original,
		},
		datePublished: article.publish_date,
		dateModified: article.publish_date,
		author: {
			'@type': 'Person',
			name: article.author_name || METADATA.APP_NAME,
		},
		publisher: {
			'@type': 'Organization',
			name: 'Hallobumil',
			logo: {
				'@type': 'ImageObject',
				url: METADATA.WEB_URL + '/hallobumil-logo.png',
				width: '262',
				height: '75',
			},
		},
		description: article.short_desc || article.title,
	};
	const hb = {
		'@context': 'https://schema.org',
		'@type': 'Organization',
		name: 'Hallobumil',
		logo: METADATA.WEB_URL+'/hallobumil-logo.png',
		url: METADATA.WEB_URL,
	};

	const medicalWebPage = {
		'@context': 'https://schema.org',
		'@type': 'MedicalWebPage',
		about: {
			'@type': 'MedicalCondition',
			name: [article.title],
		},
		lastReviewed: article.publish_date,
		reviewedBy: article.reviewer_name || METADATA.APP_NAME,
		specialty: 'http://schema.org/undefined',
	};

	const stripHtml = (html: string) => {
		return html.replace(/<[^>]+>/g, '').trim();
	};

	const faqArticlesWebPage = {
		'@context': 'https://schema.org',
		'@type': 'FAQPage',
		mainEntity: !article?.faq_articles ? [] : article?.faq_articles?.map((item: any) => ({
			'@type': 'Question',
			name: item.question,
			acceptedAnswer: {
			'@type': 'Answer',
			text: stripHtml(item.answer),
			},
		})),
	};

	return (
		<>
			<script
				defer
				type="application/ld+json"
				dangerouslySetInnerHTML={{ __html: JSON.stringify(hb) }}
			/>

			<script
				defer
				id="NewsArticle"
				type="application/ld+json"
				// nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml
				dangerouslySetInnerHTML={{ __html: JSON.stringify(NewsArticleJson) }}
			/>

			<script
				defer
				id="MedicalWebPage"
				type="application/ld+json"
				// nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml
				dangerouslySetInnerHTML={{ __html: JSON.stringify(medicalWebPage) }}
			/>

			{article?.faq_articles && article.faq_articles.length > 0 && (
				<script
					defer
					id="FAQPage"
					type="application/ld+json"
					// nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml
					dangerouslySetInnerHTML={{ __html: JSON.stringify(faqArticlesWebPage) }}
				/>
			)}
		</>
	);
};

export default NewsArticleJsonLdC;
